import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { MainBuyer } from '@dill/dill-shared';

export interface PreviewState {
  isPreviewMode: boolean;
  previewMainBuyer: MainBuyer | null;
  returnPath: string | null;
  previewSupplierDomainId: string | null;
}

const initialState: PreviewState = {
  isPreviewMode: false,
  previewMainBuyer: null,
  returnPath: null,
  previewSupplierDomainId: null,
};

export const previewSlice = createSlice({
  name: 'preview',
  initialState,
  reducers: {
    enterPreviewMode: (
      state,
      action: PayloadAction<{
        mainBuyer: MainBuyer;
        returnPath: string;
        previewSupplierDomainId: string;
      }>
    ) => {
      state.isPreviewMode = true;
      state.previewMainBuyer = action.payload.mainBuyer;
      state.returnPath = action.payload.returnPath;
      state.previewSupplierDomainId = action.payload.previewSupplierDomainId;
    },
    exitPreviewMode: (state) => {
      state.isPreviewMode = false;
      state.previewMainBuyer = null;
      state.returnPath = null;
      state.previewSupplierDomainId = null;
    },
  },
});

export const { enterPreviewMode, exitPreviewMode } = previewSlice.actions;
export default previewSlice.reducer;
